import axiosInstance from '../../../api/axiosConfig';

const BASE = '/company-portal';

const sigcodService = {
  // NO hay metodo de login. La autenticacion con SIGCOD es AUTOMATICA.
  // El middleware ensureSigcodAuth en el backend obtiene el JWT via token exchange.

  // Stats
  getStats: async () => {
    const response = await axiosInstance.get(`${BASE}/stats`);
    return response.data;
  },

  // Requests
  getRequests: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/requests`, { params });
    return response.data;
  },

  getRequestById: async (id) => {
    const response = await axiosInstance.get(`${BASE}/requests/${id}`);
    return response.data;
  },

  createRequest: async (data) => {
    const response = await axiosInstance.post(`${BASE}/requests`, data);
    return response.data;
  },

  updateRequest: async (id, data) => {
    const response = await axiosInstance.put(`${BASE}/requests/${id}`, data);
    return response.data;
  },

  resubmitRequest: async (id, data) => {
    const response = await axiosInstance.post(`${BASE}/requests/${id}/resubmit`, data);
    return response.data;
  },

  confirmReceipt: async (id) => {
    const response = await axiosInstance.post(`${BASE}/requests/${id}/confirm-receipt`);
    return response.data;
  },

  digitalReturn: async (id) => {
    const response = await axiosInstance.post(`${BASE}/requests/${id}/digital-return`);
    return response.data;
  },

  getDocuments: async (solicitudId) => {
    const response = await axiosInstance.get(`${BASE}/requests/${solicitudId}/documents`);
    return response.data;
  },

  getDownloadUrl: async (solicitudId, docId) => {
    const response = await axiosInstance.get(`${BASE}/requests/${solicitudId}/documents/${docId}/download`);
    return response.data;
  },

  getComments: async (solicitudId) => {
    const response = await axiosInstance.get(`${BASE}/requests/${solicitudId}/comments`);
    return response.data;
  },

  addComment: async (solicitudId, data) => {
    const response = await axiosInstance.post(`${BASE}/requests/${solicitudId}/comments`, data);
    return response.data;
  },

  // Returns
  getReturns: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/returns`, { params });
    return response.data;
  },

  getReturnById: async (id) => {
    const response = await axiosInstance.get(`${BASE}/returns/${id}`);
    return response.data;
  },

  createReturn: async (data) => {
    const response = await axiosInstance.post(`${BASE}/returns`, data);
    return response.data;
  },

  // Deliveries
  getDeliveries: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/deliveries`, { params });
    return response.data;
  },

  getPendingDeliveries: async () => {
    const response = await axiosInstance.get(`${BASE}/deliveries/pending`);
    return response.data;
  },

  signDelivery: async (id, signatureData) => {
    const response = await axiosInstance.post(`${BASE}/deliveries/${id}/sign`, { signatureData });
    return response.data;
  },

  // Transfers
  getTransfers: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/transfers`, { params });
    return response.data;
  },

  getTransferById: async (id) => {
    const response = await axiosInstance.get(`${BASE}/transfers/${id}`);
    return response.data;
  },

  createTransfer: async (data) => {
    const response = await axiosInstance.post(`${BASE}/transfers`, data);
    return response.data;
  },

  updateTransfer: async (id, data) => {
    const response = await axiosInstance.put(`${BASE}/transfers/${id}`, data);
    return response.data;
  },

  // Shared documents
  getSharedDocuments: async () => {
    const response = await axiosInstance.get(`${BASE}/shared-documents`);
    return response.data;
  },
};

export default sigcodService;
